import { Typography } from "@mui/material";

function Paragraph({ children, sx }) {
  return (
    <Typography
      sx={{
        fontSize: "16px",
        fontWeight: 400,
        color: "rgba(0, 0, 0, 0.60)",
        mb: "12px",
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}

export default Paragraph;
